import { apiService } from "../../../../services/api/apiService";
import { TreeSelectItemDto } from "../../../../types/SelectItemDto";
import { OrganizationalStructureDetailDto, OrganizationalStructureDto } from "../types";

const BASE_URL = "/organizationalStructures"

export const getOrganizationalStructureTree = async (): Promise<OrganizationalStructureDto[]> =>
    await apiService.get<OrganizationalStructureDto[]>(`${BASE_URL}/tree`);

export const getOrganizationalStructureDetailById = async (id: number): Promise<OrganizationalStructureDetailDto> =>
    await apiService.get<OrganizationalStructureDetailDto>(`${BASE_URL}/${id}`);

export const createOrganizationalStructure = async (body: OrganizationalStructureDetailDto): Promise<OrganizationalStructureDetailDto> =>
    await apiService.post<OrganizationalStructureDetailDto, OrganizationalStructureDetailDto>(`${BASE_URL}/`, body);

export const updateOrganizationalStructure = async (id: number, body: OrganizationalStructureDetailDto): Promise<OrganizationalStructureDetailDto> =>
    await apiService.put<OrganizationalStructureDetailDto, OrganizationalStructureDetailDto>(`${BASE_URL}/${id}`, body);

export const deleteOrganizationalStructure = async (id: number): Promise<void> =>
    await apiService.put(`${BASE_URL}/delete/${id}`, null);

export const getOrganizationalStructureOptions = async (): Promise<TreeSelectItemDto[]> =>
    await apiService.get<TreeSelectItemDto[]>(`${BASE_URL}/select`);

export const getOrganizationalStructureOptionsByUser = async (): Promise<TreeSelectItemDto[]> =>
    await apiService.get<TreeSelectItemDto[]>(`${BASE_URL}/selectByUser`);
